export const types = [
  {
    value: "onboarding",
    label: "Onboarding",
  },
  {
    value: "support",
    label: "Support",
  },
  {
    value: "survey",
    label: "Survey",
  },
  {
    value: "feedback",
    label: "Feedback",
  },
  {
    value: "other",
    label: "Other",
  },
];
